<template>
  <div class="event-products">
    <!--    <div class="header">
          <div class="header_section">
            <router-link to="/profile" class="header_element header_icone mobile">
              &lt;!&ndash;          <span class="icon icon-left-arrow icon-lg"></span>&ndash;&gt;
              <font-awesome-icon color="#00d7fe" class="reverse" icon="angle-right"/>

            </router-link>
            <h1 class="header_element">{{ events.event_name }} Produits</h1>
          </div>
        </div>-->
    <div class="filter-container">
      <div class="filter">
        <select name="type" @change="filterProducts" v-model="type">
          <option value=""> - Filter par attribution -</option>
          <option value=1>Attribué</option>
          <option value=0>Non Attribué</option>
        </select>
      </div>
      <div class="filter">
        <select name="animal" @change="filterProducts" v-model="modele">
          <option value=""> - Filtrer par animal -</option>
          <option value='ours'>Ours</option>
          <option value='loup'>Loup</option>
          <option value='panda'>Panda</option>
          <option value='cerf'>Cerf</option>
          <option value='elephant'>Elephant</option>
        </select>
      </div>
      <span class="count desktop" v-if="this.products">
           {{ this.productList.length }}/
        {{ this.products.length }}
        </span>
      <span class="mobile" v-if="this.products">Résultat :
           {{ this.productList.length }}/
        {{ this.products.length }}
        </span>
    </div>
    <div class="product-list">
      <div class="product" v-for="product in productList">
        <img :src="product.id_product.image_tatouage" width="100%" alt="">
        <div class="propriate">
          <img :src="product.id_user.avatar" alt="" v-if="product.id_user">
          <img :src="user.avatar" alt="" v-else>
          <span>{{ product.id_user ? product.id_user.name : 'non attribué' }}</span></div>
      </div>
    </div>

  </div>
</template>

<script>
import {store} from '../../../store/store';
import {mapState, mapActions} from "vuex";

import LightBox from 'vue-image-lightbox'

export default {
  name: 'gallery',
  props: [
    'event',
  ],
  components: {
    LightBox,
  },
  data() {
    return {
      // medias:store.getters.getMedias,
      products: null,
      productList: null,
      modele: "",
      type: "",
    }
  },
  computed: {
    ...mapState([
      'user'
    ])
  },
  methods: {
    ...mapActions([
      'getEventProducts'
    ]),
    filterProducts() {

      if (this.type) {
        if (parseInt(this.type)) {
          this.productList = this.products.filter(el => el.id_user)
        } else {
          this.productList = this.products.filter(el => el.id_user === null)
        }
        if (this.modele) {
          this.productList = this.productList.filter(el => el.id_product.image_mask.includes(this.modele))
        }
      }

      if (this.modele && !this.type) {
        this.productList = this.products.filter(el => el.id_product.image_mask.includes(this.modele))
      }

    }
  },
  mounted() {
    // this.medias = localStorage.getItem('medias')
    !localStorage.getItem('user') && this.$router.push({name: "login", params: {type: 'connexion'}});

    this.getEventProducts(this.event.id).then(res => {
      this.products = res
      this.productList = this.products
    })
  }
}
</script>

<style scoped>
@import "https://use.fontawesome.com/releases/v5.0.6/css/all.css";
@import "https://cdn.jsdelivr.net/npm/animate.css@3.5.1";

.gallery {
  z-index: 1;
  background: #fff;
}

.header {
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
}

.header_section {
  display: flex;
  align-items: center;
  text-align: center;
}

.header_section:first-child {
  justify-content: center;
  width: 100%;
}

.header_section:first-child .header_element:first-child {
  position: absolute;
  left: 10px;
}

.header_element {
  margin: 0 0 0 10px;
  color: #00d7fe;
  text-decoration: none;
}

h1.header_element {
  font-size: 3em;
  /*border-bottom:4px solid #00d7fe;*/
  padding: 0;
  position: relative;
}

.header_icone {
  font-size: 30px;
  /*line-height: 80px;*/
}

.product-list {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.product {
  width: 150px;
  position: relative;
  padding: 10px;
  margin: 15px 0;
  border: 1px solid var(--main-color);
  border-radius: 10px;
}

.product .propriate {
  position: absolute;
  width: 100%;
  bottom: -10px;
  left: -10px;
  z-index: 1;
  display: flex;
  align-items: center;
}

.product .propriate img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid var(--main-color);
  position: absolute;
  z-index: 2;
}

.product .propriate span {
  background: #fff;
  border: 1px solid var(--main-color);
  padding: 5px 20px;
  border-radius: 5px;
  margin-left: 30px;

}

.filter-container {
  display: flex;
  align-items: center;
  position: relative;
}

.filter-container .filter {
  margin: 10px;

}

.filter-container select {
  padding: 5px;
}

.filter-container .count {
  position: absolute;
  right: 0;
}


.selected {
  color: #00d6ff;
  border-bottom: 3px solid #00d6ff;
}


.mobile {
  display: none;
}

@media screen and (max-width: 750px) {
  .desktop {
    display: none;
  }

  .mobile {
    display: block;
  }

  .filter-container {
    flex-wrap: wrap;
  }

  .filter-container span {
    margin: 10px;
  }

}

</style>
